
export enum RoutePath {
    AppRoot = '',
    Home = '/',
    Invalid = '**',
    Dashboard = 'dashboard',
    Analyze = 'analyze',
    Administration = 'administration',
    EdgeDevice = 'edgeDevice',
    Login = 'login',
    PasswordForgot = 'passwordForgot',
    User = 'user',
    Report = 'report',
    Visual = 'visual',
    UserReport = 'userReport'
}